module.exports = __webpack_public_path__ + "img/mbo-certified-seal-whitebg-lg.0d6a159c.svg";